// extracted by mini-css-extract-plugin
export default {"header":"RegionsModal__header-LxG3I"};